export default __webpack_public_path__ + "static/media/success-purchase.d29b268b.svg";